module.exports = __webpack_public_path__ + "img/welfare-ico-2.a2988ca9.png";